/**
 * Tap sounds shared by the block drag handles (spacing, width).
 * Loaded lazily on first interaction so the audio files aren't fetched for readers.
 */
const SOUND_URLS = [1, 2, 3, 4, 5].map(i => `/assets/sound-effects/tap_0${i}.wav`);

let sounds = null;

/** Load sound effects (called once globally on first interaction) */
export function load_sounds() {
  if (sounds) return;
  sounds = SOUND_URLS.map(url => {
    const audio = new Audio(url);
    audio.preload = 'auto';
    return audio;
  });
}

/**
 * Play the sound for a step index
 * @param {number} index
 */
export function play_sound(index) {
  if (!sounds || index < 0 || index >= sounds.length) return;
  const audio = sounds[index];
  audio.currentTime = 0;
  audio.play().catch(() => {}); // Ignore autoplay errors
}
